module.exports = __webpack_public_path__ + "img/axo_feliz.c6bbb5f8.svg";